module.exports = __webpack_public_path__ + "static/img/b9.ed9d043.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/b9.jpg
// module id = z3X+
// module chunks = 1